import { Box, Image } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import VSIbase from "../utills/images/VSIbase.jpg";
import VSIline from "../utills/images/VSIline.png";

function Director({ onScoreChange }) {
    const [rotateDegree, setRotateDegree] = useState(0);
    const [score, setScore] = useState(0);
    const [tq, setTq] = useState(0);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "ArrowLeft") {
                setRotateDegree((prevPosition) => prevPosition - 10);
            } else if (event.key === "ArrowRight") {
                setRotateDegree((prevPosition) => prevPosition + 10);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (rotateDegree === 0) {
            setScore((prev) => prev + 1);
        }
    }, [rotateDegree]);

    useEffect(() => {
        const interval = setInterval(() => {
            const randomDirection = Math.random() < 0.5 ? -1 : 1; // Randomly choose clockwise (-1) or counterclockwise (1) direction
            const newRotateDegree = rotateDegree + randomDirection * 10; // Rotate by 30 degrees
            setRotateDegree(newRotateDegree);
            setTq((prev) => prev + 1);
        }, 2000);
        return () => clearInterval(interval);
    }, [rotateDegree]);

    useEffect(() => {
        let temp = Math.floor((score / tq) * 100);
        onScoreChange(temp, "directorScore");
    }, [score])

    return (
        <Box
            className="directorscreen"
            pos="relative"
            w="290px"
            h="290px"
            bgImage={`url(${VSIbase})`}
            bgSize="cover"
            borderRadius="15px"
            transition="background-position 0.5s ease-in-out"
        >
            <Box
                transform={`rotate(${rotateDegree}deg)`}
                transition="transform 0.5s ease-in-out"
                pos="relative"
            >
                <Image src={VSIline} alt="vsiline" />
            </Box>
        </Box>
    );
}

export default Director;
